function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useMemo, useRef } from "react";
import ThemeContext from "../ThemeProvider/ThemeContext";
import { getStyle } from "./LoadingIcon.style";
import { deprecatedPropValueMessage } from "../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
export var LoadingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, id = param.id;
    var getKey = function getKey() {
        if (keyCount < Number.MAX_SAFE_INTEGER - 1) {
            return keyCount++;
        }
        keyCount = 1;
        return keyCount;
    };
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'LoadingIcon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var style = _objectSpread({}, useStyle(size));
    var keyCount = 1;
    var strokeId = useRef(id || getKey());
    return _jsx("div", {
        css: style.outerContainerStyle,
        children: _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            css: style.circleStyle,
            fill: "transparent",
            children: [
                _jsx("defs", {
                    children: _jsxs("linearGradient", {
                        id: strokeId.current.toString(),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: style.gradientColor1
                            }),
                            _jsx("stop", {
                                offset: "50%",
                                stopColor: style.gradientColor2
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: style.gradientColor3
                            })
                        ]
                    })
                }),
                _jsx("circle", {
                    cx: "50%",
                    cy: "50%",
                    r: '45%',
                    stroke: style.rail,
                    strokeLinecap: "round",
                    fill: "transparent"
                }),
                _jsx("circle", {
                    stroke: "url(#".concat(strokeId.current, ")"),
                    cx: "50%",
                    cy: "50%",
                    r: '45%',
                    css: _objectSpread({}, style.tailChaserStyle)
                })
            ]
        })
    });
};
function useStyle(size) {
    var theme = useContext(ThemeContext);
    var ref = useMemo(function() {
        return getStyle(theme);
    }, [
        theme
    ]), outerContainer = ref.outerContainer, circle = ref.circle, tailChaser = ref.tailChaser, defaultColors = ref.defaultColors;
    return {
        outerContainerStyle: _objectSpread({}, outerContainer.base),
        circleStyle: _objectSpread({}, circle.base, size === 'xl' ? circle.l : {}, size === 'l' ? circle.l : {}, size === 'm' ? circle.m : {}, size === 's' ? circle.s : {}),
        tailChaserStyle: _objectSpread({}, tailChaser.base, size === 'xl' ? tailChaser.l : {}, size === 'l' ? tailChaser.l : {}, size === 'm' ? tailChaser.m : {}, size === 's' ? tailChaser.s : {}),
        gradientColor1: defaultColors.gradientColor1,
        gradientColor2: defaultColors.gradientColor2,
        gradientColor3: defaultColors.gradientColor3,
        rail: defaultColors.rail
    };
}
export default LoadingIcon;
